import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

export interface MoveNodeRequest {
  nodeIds: string[];
  newParentNodeId: string;
  selectAll?: boolean;
}

export const batchMoveNodes = async (
  { nodeIds, newParentNodeId, selectAll }: MoveNodeRequest,
  options: ServiceRequestConfig = {},
) => {
  const response = await managedEntities.patch(
    '/nodes/batch-move',
    {
      node_ids: nodeIds,
      new_parent_node_id: newParentNodeId,
      select_all: selectAll,
    },
    { showErrorToast: true, ...options },
  );
  return response.data;
};
